<template>
  <div>
    <div>
      <el-row>
        <el-col :span="24" class="top">
          <div class="top_content">
            <el-button type="text" @click="gotoMerchant">切换到商户中心</el-button>
            <el-button type="text" @click="gotoProvider">切换到服务商中心</el-button>
            <el-button type="text">您好，<span v-html="clientName" /></el-button>
            <el-button v-if="show" type="text" @click="changeRole()">[身份切换]</el-button>
            <el-button type="text" @click="logout">[退出]</el-button>
            <!--<el-button type="text">帮助中心</el-button>-->
            <el-button type="text">返回官网</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="head_title">
          <div class="head_content">
            <div class="img_box">
              <el-image :src="logo" />
            </div>
            <span class="header_slogan">让支付更有温度</span>
            <el-button
              type="text"
              style="margin-right: 30px"
              @click="$router.push({ path: '/index' })"
            >DoPay钱包</el-button>
            <el-button
              type="text"
              style="margin-right: 30px"
              @click="$router.push({ path: '/info' })"
            >客户资料</el-button>
            <el-button
              type="text"
              style="margin-right: 30px"
              @click="$router.push({ path: '/trade' })"
            >交易记录</el-button>
            <el-button
              type="text"
              style="margin-right: 30px"
              @click="$router.push({ path: '/bank-card' })"
            >银行卡管理</el-button>
            <el-button
              type="text"
              style="margin-right: 30px"
              @click="$router.push({ path: '/security' })"
            >安全中心</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/logo.png'
import Session from '@/utils/session'
import mfe88 from '@/utils/mfe88'
export default {
  name: 'Header',
  data() {
    return {
      logo: logo,
      userName: null,
      clientName: Session.getItem('customerName'),
      clientList: [],
      show: true
    }
  },
  mounted() {
    this.isShow()
  },
  methods: {
    isShow() {
      const customerLength = localStorage.getItem('customerLength')
      if (customerLength === '1') {
        this.show = false
      } else {
        this.show = true
      }
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      await this.$router.push({ path: '/login' })
      localStorage.removeItem('customerLength')
      localStorage.removeItem('operLength')
      sessionStorage.removeItem('showTrue')
      sessionStorage.removeItem('showBanklist')
    },
    gotoMerchant() {
      window.location.href = mfe88.merchantUrl
    },
    gotoProvider() {
      window.location.href = mfe88.providerUrl
    },
    // changeRole() {
    //   this.$router.push({
    //     name: 'cusList',
    //     params: { type: '2' }
    //   })
    // }
    async changeRole() {
      Session.removeItem('merName')
      Session.removeItem('customerId')
      sessionStorage.removeItem('showTrue')
      sessionStorage.removeItem('showBanklist')
      localStorage.removeItem('pcoCode')
      localStorage.removeItem('pcoName')
      localStorage.removeItem('merNo')
      localStorage.removeItem('merName')
      localStorage.removeItem('merStatus')
      localStorage.removeItem('customerLength')
      localStorage.removeItem('operLength')
      // this.$store.dispatch('permission/generateRoutes', [])
      // await this.$store.dispatch('user/resetToken')
      await this.$store.dispatch('user/logout')
      this.$router.push({
        path: '/login',
        query: { type: '2' }
      })
    }
  }
}
</script>

<style scoped>
.top {
  background: rgba(250, 250, 250, 1);
  height: 34px;
}
.top_content,
.head_content {
  width: 1000px;
  height: 100%;
  margin: auto;
  display: flex;
}
.top_content > .el-button--text {
  font-size: 12px;
  color: #909090;
  margin: 0;
}

.top_content > .el-button--text:nth-of-type(2) {
  margin-left: 25px;
}
.top_content > .el-button--text:nth-of-type(3) {
  margin-left: 540px;
  margin-right: 18px;
}
.top_content > .el-button--text:nth-of-type(4) {
  margin-right: 23px;
}
.head_title {
  background: #ffffff;
  height: 83px;
}
.head_content {
  align-items: center;
}
.el-image {
  width: 132px;
  height: 42px;
  overflow: hidden;
}

.head_content > .el-button--text {
  font-size: 15px;
  color: #333333;
  font-weight: 500;
  margin: 0;
  padding: 0;
}
.header_slogan {
  padding-left: 50px;
  line-height: 81px;
  letter-spacing: 8px;
  color: rgb(249, 0, 62);
  font-size: 12px;
  margin-right: 180px;
}
</style>
